/**
 * Constants for medication reconciliation insight rule names
 */

export const MEDREC_RULE_NAMES = {
  POTENTIAL_DUPLICATE: "Potential Duplicate",
  POTENTIAL_TREATMENT_GAP: "Potential Treatment Gap",
  MISSING_END_DATE: "Missing End Date",
  PSYCHOTROPIC_MEDS_STEWARDSHIP: "Psychotropic Meds Stewardship",
  MISSING_SAFETY_PARAMETERS: "Missing Safety Parameters",
} as const;

/** Legacy alias — old backend data may still use this value */
export const LEGACY_REASSESSMENT_NEEDED = "Reassessment Needed";

/**
 * Normalize a rule name so legacy "Reassessment Needed" maps to "Missing End Date".
 */
export function normalizeMedRecRuleName(name: string): string {
  if (name === LEGACY_REASSESSMENT_NEEDED)
    return MEDREC_RULE_NAMES.MISSING_END_DATE;
  return name;
}

/**
 * Type representing valid medication reconciliation rule names
 */
export type MedRecRuleName =
  | typeof MEDREC_RULE_NAMES.POTENTIAL_DUPLICATE
  | typeof MEDREC_RULE_NAMES.POTENTIAL_TREATMENT_GAP
  | typeof MEDREC_RULE_NAMES.MISSING_END_DATE
  | typeof MEDREC_RULE_NAMES.PSYCHOTROPIC_MEDS_STEWARDSHIP
  | typeof MEDREC_RULE_NAMES.MISSING_SAFETY_PARAMETERS;

/**
 * Display name mappings for rule names
 */
export const MEDREC_RULE_DISPLAY_NAMES: Record<MedRecRuleName, string> = {
  [MEDREC_RULE_NAMES.POTENTIAL_DUPLICATE]: "Duplicates",
  [MEDREC_RULE_NAMES.POTENTIAL_TREATMENT_GAP]: "Treatment Gaps",
  [MEDREC_RULE_NAMES.MISSING_END_DATE]: "Missing End Dates",
  [MEDREC_RULE_NAMES.PSYCHOTROPIC_MEDS_STEWARDSHIP]: "Psych Stewardship",
  [MEDREC_RULE_NAMES.MISSING_SAFETY_PARAMETERS]: "Safety Parameters",
};
